import React from 'react';
import parser from 'html-react-parser';
import Button from '../Button';

export default function ServiceInfo({
  sectionTitleDown,
  textVariant,
  sectionBtnUrl,
  sectionBtnText,
}) {
  return (
    <div className="cs_service_1-info text-center cs_mt_40 d-flex justify-content-center align-items-center flex-wrap">
      {sectionTitleDown && (
        <h4 className={`fw-normal m-0 ${textVariant}`}>
          {parser(sectionTitleDown)}
        </h4>
      )}
      {sectionBtnText && sectionBtnUrl && (
        <Button btnText={sectionBtnText} btnUrl={sectionBtnUrl} />
      )}
    </div>
  );
}
